import {DataFetcher} from '@aboutyou/data-fetcher';
import React from 'react';
import {useCanShowCouponsMinimal} from '../../../../../features/Coupons/useCanShowCoupons';
import {useProminentBannerSection} from '../../../ProductInformationBox/MiniArticleDetail/useGetMinimalProductBulkSection';
import {CouponHintView} from './CouponHintView';

export const CouponHintMinimal: React.FC<{productId: number}> = props => {
  const request = useProminentBannerSection(props.productId);
  const canShowCouponsMinimal = useCanShowCouponsMinimal(props.productId);

  if (!canShowCouponsMinimal) {
    return null;
  }

  return (
    <DataFetcher
      request={request}
      Error={null}
      viewProps={props}
      View={viewProps => <CouponHintView {...viewProps} isInMiniADPDialog />}
    />
  );
};
